import { apiRequest } from "../../lib/api-client";
import type {
  LoginPayload,
  LoginResult,
  MfaSetup,
  MfaStatus,
  MfaTokenResponse,
} from "./types";

export function loginRequest(payload: LoginPayload) {
  return apiRequest<LoginResult>("/auth/login", {
    method: "POST",
    body: {
      company_code: payload.companyCode,
      username: payload.username,
      password: payload.password,
    },
  });
}

export function verifyMfaLogin(challengeToken: string, code: string) {
  return apiRequest<MfaTokenResponse>("/auth/mfa/verify", {
    method: "POST",
    body: { mfa_challenge_token: challengeToken, code },
  });
}

export function getMfaStatus() {
  return apiRequest<MfaStatus>("/auth/mfa/status");
}

export function setupMfa() {
  return apiRequest<MfaSetup>("/auth/mfa/setup", { method: "POST" });
}

export function enableMfa(code: string) {
  return apiRequest<MfaStatus>("/auth/mfa/enable", {
    method: "POST",
    body: { code },
  });
}

export function disableMfa(code: string) {
  return apiRequest<MfaStatus>("/auth/mfa/disable", {
    method: "POST",
    body: { code },
  });
}

export function requestPasswordReset(companyCode: string, username: string) {
  return apiRequest<{ message: string }>("/auth/forgot-password", {
    method: "POST",
    body: { company_code: companyCode, username },
  });
}

export function performPasswordReset(token: string, newPassword: string) {
  return apiRequest<{ message: string }>(`/auth/reset-password/${encodeURIComponent(token)}`, {
    method: "POST",
    body: { new_password: newPassword },
  });
}
